import React, {useEffect, useRef, useState} from "react";
import {SaveButton} from "../../../../../components/button/SaveButton";
import {CancelButton} from "../../../../../components/button/CancelButton";
import {t} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslation} from "../../CommonTranslation";
import Dialog from "../../../../../components/dialogs/Dialog";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import TextField from "../../../../../components/fields/textfield/TextField";
import DialogActions from "../../../../../components/dialogs/DialogActions";
import Snackbar from "../../snackbar/Snackbar";
import Grid from "../../../../../components/dialogs/Grid";
import {getLabelForPropertyType} from "../PropertyType";
import {PropertyValidator} from "../PropertyValidator";
import {PropertyDto} from "../../../../../common/apis/property/PropertyApi";
import {PropertiesTranslationKey} from "../PropertiesTranslationKey";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";


export interface PropertyUpdateApi {
    updateProperty: (propertyDefinitionId: string, value: string) => Promise<void>;
}

interface PropertyUpdateDialogProps {
    open: boolean;
    property: PropertyDto;
    propertyUpdateApi: PropertyUpdateApi;
    onUpdated: () => void;
    onClosed: () => void;
}

export default function PropertyUpdateDialog(props: Readonly<PropertyUpdateDialogProps>) {
    const {open, property, propertyUpdateApi, onUpdated, onClosed} = props
    const [value, setValue] = useState<string>(property.value);
    const [valueValidationMsg, setValueValidationMsg] = useState<string | undefined>(undefined);

    const validator = useRef(new PropertyValidator());

    useEffect(() => {
        setValue(property.value);
        setValueValidationMsg(undefined);
    }, [property]);

    function validateValue(): boolean {
        const isValid = validator.current.validateValue(value);
        setValueValidationMsg(isValid ? undefined : t(CommonTranslation.FILL_OUT_THIS_FIELD));
        return isValid;
    }

    function updateProperty() {
        const isValueValid = validateValue();
        if (isValueValid) {
            propertyUpdateApi.updateProperty(property.definition.identifier, value)
                .then(() => {
                    onUpdated();
                    onClosed();
                    Snackbar.success(t(PropertiesTranslationKey.PROPERTY_UPDATED_SUCCESSFULLY));
                })
                .catch((error) => Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error));
        }
    }

    return (
        <Dialog open={open} onClose={onClosed}>
            <DialogTitle id="scroll-dialog-title"
                         title={t(PropertiesTranslationKey.UPDATE_PROPERTY)}
                         onDialogClosed={onClosed}/>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <TextField id="name-field"
                                   label={t(PropertiesTranslationKey.NAME)}
                                   value={property.definition.name}
                                   disabled={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField id="type-field"
                                   label={t(PropertiesTranslationKey.TYPE)}
                                   value={getLabelForPropertyType(property.definition.type)}
                                   disabled={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField id="value-field"
                                   label={t(PropertiesTranslationKey.VALUE)}
                                   value={value}
                                   required={true}
                                   errorMessage={valueValidationMsg}
                                   onChange={(newValue) => setValue(newValue)}/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <SaveButton onClick={updateProperty}/>
                <CancelButton onClick={onClosed} variant={"outlined"}/>
            </DialogActions>
        </Dialog>
    );
}
